import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Landing from 'components/pages/landing/Landing';
import Blog from 'components/pages/blog/Blog';
import BlogPost from 'components/pages/blog/BlogPost';
import CatalogEnricherDemo from 'components/pages/demo/CatalogEnricherDemo';

const FalconRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/demo" element={<CatalogEnricherDemo />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
};

export default FalconRoutes;
